const mapping = {
  "zh": "chs", 
  "de": "deu", 
  "en": "enu", 
  "es": "esp",
  "fr": "fra", 
  "ja": "jpn", 
  "pt": "ptb",
  "ar": "ara",
  "arabia_en": "enu",
  "ru":"rus"
}

export default mapping;
